import GoCard from "./go-card.vue";
import GoLayout from "./go-layout.vue";
import GoLayoutPanel from "./go-layout-panel.vue";
import GoComponentsTabs from "./go-components-tabs.vue";
import goTabPanelBody from "./go-tab-panel-body.vue";
import GoPanel from "./go-panel.vue";
import GoWizard from "./go-wizard.vue";
import GoWizardPanel from "./go-wizard-panel.vue";
import GoSteps from "./go-steps.vue";
import GoTabRouter from "./go-tab-router.vue";
import GoStepsPages from "./go-steps-pages.vue";
import GoStepPage from "./go-step-page.vue";
import GoStepsSimple from "./go-steps-simple.vue";
import GoIframe from "./go-iframe.vue";
import GoSimpleCard from "./go-simple-card";
import goSimpleCardTwo from "./go-simple-card-two";
//分组组件
import goFieldset from "./go-fieldset";

export default {
    goSimpleCardTwo,
    GoSimpleCard,
    GoStepsPages,
    GoStepPage,
    GoIframe,
    GoCard,
    GoLayout,
    GoLayoutPanel,
    GoPanel,
    goTabPanelBody,
    GoWizard,
    GoWizardPanel,
    GoTabRouter,
    GoSteps,
    GoStepsSimple,
    GoComponentsTabs,
    goFieldset
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/layoutVue/index.js